import { useEffect } from "react";
import React, { useState } from "react";
import moment from 'moment';
import DatePicker from "react-datepicker";
import { Card, CardContent, Grid, Tab, Tabs } from "@material-ui/core";
import MaterialTable from "material-table";
import "./PaymentByChef.css";
import API from "../../utils/api";
import tableIcons from "../common/Table/tableIcons";
import { paymentTableConfig, paymentByDateTableConfig } from "./config";
import { getPaymentModes } from "../../actions/chefsandrestaurants";
import { GET_PAYMENTS_BY_CHEE } from "../../constants";
import Button from "../common/Button";


const PaymentByChef = ({
   sellerId,
   classes,
   url,
   isLoading = false,
   title = "",
   // data = [],
   noBorder = false,
   globalSearch = true,
   filtering = true,
}) => {
   const recordsPerPage = 10
   const tabs = [{
      key: 0,
      label: "Daily",
      name: "daily"
   }, {
      key: 1,
      label: "Weekly",
      name: "weekly"
   }, {
      key: 2,
      label: "Monthly",
      name: "monthly"
   }]

   const [selectedDurationTime, setSelectedDurationTime] = useState(0)
   const [key, setKey] = useState(0)
   const [localization, setLocale] = useState({});
   const [countryId, setCountryId] = useState(null);
   const [paymentModesData, setPaymentModesData] = useState([]);
   // const [searchData, setSearchData] = useState({
   //    fromDate: new Date().setDate(new Date().getDate() - 7),
   //    toDate: new Date()
   // });

   const [searchData, setSearchData] = useState([new Date().setDate(new Date().getDate() - 7), new Date()]);
   const [fromDate, toDate] = searchData;
   let session = sessionStorage.getItem('user');

   useEffect(() => {
      if (session) {
         setCountryId(`${JSON.parse(session).findAdmin.country_id}`)
      }
   }, [session])

   useEffect(() => {
      fetchPaymentModes(countryId)
   }, [countryId])

   const fetchPaymentModes = async (countryId) => {
      try {
         if (!countryId) {
            return
         }

         const response = await getPaymentModes(countryId)
         if (response && response.data && response.data.ResponseData) {
            setPaymentModesData(response.data.ResponseData)
            setKey(key + 1)
         }
      } catch (error) {
         console.log(error);
      }
   }


   const config = paymentByDateTableConfig().columns.map((configItem) => {
      return {
         ...configItem,
         sorting: configItem.filterAndSearch,
         filtering: configItem.filterAndSearch,
         filterPlaceholder: 'Search',
         searchable: configItem.filterAndSearch
      }
   });

   const ordersColumnsConfig = paymentTableConfig().columns.map((configItem) => {
      return {
         ...configItem,
         sorting: configItem.filterAndSearch,
         filtering: configItem.filterAndSearch,
         filterPlaceholder: 'Search',
         searchable: configItem.filterAndSearch
      }
   });

   const handleDateChange = (eventDate, name) => {
      setSearchData(eventDate)
   }

   const handleSearch = (isClear = false) => {

      const fromDate = new Date().setDate(new Date().getDate() - 7)
      const toDate = new Date()

      if (isClear) {
         setSearchData([fromDate, toDate])
      } else {
         setSearchData([
            searchData[0] || fromDate,
            searchData[1] || toDate
         ])
      }
      setKey(key + 1)
   }

   return (
      <div>
         <h5 className={classes.heading}>Payment Settlement</h5>
         <div style={{ width: '100%' }}>
            <Card>
               <CardContent>
                  <div className="row" style={{ marginLeft: '10px' }}>
                     <Grid container spacing={1} className={'d-flex align-items-center'}>
                        <Grid item xs={3}>
                           <DatePicker
                              className="form-control newchange"
                              dropdownMode="select"
                              inlineFocusSelectedMonth
                              showDisabledMonthNavigation
                              selectsRange={true}
                              maxDate={new Date()}
                              startDate={fromDate}
                              endDate={toDate}
                              onChange={(update) => {
                                 handleDateChange(update);
                              }}
                              isClearable={true}
                           />
                        </Grid>
                        <Grid item xs={1}>
                           <Button type="button" className={classes.button} label="Search" onClick={(e) => { handleSearch() }} />
                        </Grid>
                        <Grid item xs={1}>
                           <Button type="button" className={classes.button} label="Reset" onClick={(e) => { handleSearch(true) }} />
                        </Grid>
                     </Grid>
                  </div>
               </CardContent>
            </Card>
         </div>
         <MaterialTable
            style={{
               width: '100%',
               boxShadow: 'none',
               background: 'white',
               padding: '15px',
               borderRadius: noBorder ? '0px' : '5px'
            }}
            localization={localization}
            icons={tableIcons}
            columns={config || []}
            // actions={actions}
            // data={data}
            title={title}
            key={key} // for refresh and call api on refresh
            isLoading={isLoading}
            options={
               {
                  toolbar: globalSearch,
                  filtering: filtering,
                  search: false,
                  //columnsButton: false,
                  exportAllData: false,
                  // exportButton: true,
                  // exportButton: {
                  //    csv: true,
                  //    pdf: false,
                  // },
                  sorting: false,
                  hideFilterIcons: true,
                  actionsColumnIndex: -1,
                  tableLayout: 'fixed',
                  searchFieldAlignment: 'left',
                  pageSize: recordsPerPage,
                  paginationType: 'stepped',
                  pageSizeOptions: [],
                  headerStyle: {
                     backgroundColor: '#f58634',
                     color: 'white',
                     padding: '8px 0 8px 16px',
                     width: 50
                  },
                  filterCellStyle: {
                     backgroundColor: '#fef3ea',
                     padding: '8px 0 8px 16px',
                  },
                  searchFieldStyle: {
                     borderRadius: '20px',
                     border: '1px solid grey',
                     padding: '5px 35px',
                     marginBottom: '10px',
                     display: 'none'
                  }
               }
            }
            data={query =>
               new Promise((resolve, reject) => {
                  setLocale({ body: { emptyDataSourceMessage: '' } });
                  let filters = [];
                  const selectedTab = tabs.find(tab => tab.key === selectedDurationTime)
                  let painationProps = [
                     `recordsPerPage=${recordsPerPage}`,
                     `pageNo=${query.page + 1}`,
                     // `filter=${selectedTab.name}`
                  ];

                  if (query.filters.length > 0) {
                     filters = query.filters.map(
                        filter => `${filter.column.field}=${filter.value}`
                     );
                  }
                  let apiUrl = `${GET_PAYMENTS_BY_CHEE}?`;
                  apiUrl += [
                     ...filters,
                     ...painationProps
                  ].join('&');

                  const fromDate = moment().subtract(7, 'days').format("YYYY-MM-DD")
                  const toDate = moment().format("YYYY-MM-DD")

                  const [selectedFromDate, selectedToDate] = searchData;

                  const formatedFromDate = moment(selectedFromDate).format("YYYY-MM-DD")
                  const formatedToDate = moment(selectedToDate).format("YYYY-MM-DD")

                  let paymentModesDataClone = [...paymentModesData]
                  if (!paymentModesDataClone) {
                     // const response = await getPaymentModes(countryId || 1)
                     // if (response && response.data && response.data.ResponseData) {
                     //    paymentModesDataClone = [...response.data.ResponseData]
                     // }
                  }

                  const venderData = (paymentModesDataClone || []).find(paymentMode => paymentMode.paymentMode === "Paytm")
                  const venderId = (venderData && venderData.vendor_id) || 1

                  const paymnetReqPayload = {
                     "seller_id": sellerId,
                     "fromDate": formatedFromDate || fromDate,
                     "toDate": formatedToDate || toDate,
                     "vendor_id": venderId
                  }

                  API.post(apiUrl, paymnetReqPayload).then(response => {
                     console.log("response---------------", response);
                     const result = response.data.ResponseData || {};

                     const orderCount = result.daily_orders.reduce((total, next_order) => total + next_order.total_order, 0)
                     const orders = result.daily_orders.filter((order) => order.total_order)

                     const paymentData = []
                     if (orders.length > 0) {
                        paymentData.push({
                           fromDate: formatedFromDate || fromDate,
                           toDate: formatedToDate || toDate,
                           total_revenue: result.total_revenue || 0,
                           daily_orders: orders || [],
                           totalOrders: orderCount || 0
                        })
                     }
                     resolve({
                        data: paymentData || [],
                        page: query.page,
                        totalCount: response.data.ResponseData.totalCount || 10
                     });
                     setLocale({
                        body: {
                           emptyDataSourceMessage: isLoading
                              ? ''
                              : 'No Settlement data found for selected dates.'
                        }
                     });
                  });
               })
            }
            detailPanel={rowData => {
               return (
                  <div id={"order-listing-table"} className={classes.orderTable}>
                     <div className="payment-chef-table-wrapper">
                        <MaterialTable
                           style={{
                              width: '100%',
                              boxShadow: 'none',
                              background: 'white',
                              padding: '15px',
                              borderRadius: noBorder ? '0px' : '5px',
                              height: 'auto'
                           }}
                           key={rowData.id}
                           columns={ordersColumnsConfig}
                           data={rowData.daily_orders || []}
                           icons={tableIcons}
                           title={title}
                           isLoading={isLoading}
                           options={{
                              search: true,
                              toolbar: globalSearch,
                              filtering: filtering,
                              sorting: true,
                              exportAllData: false,
                              exportButton: false,
                              hideFilterIcons: true,
                              actionsColumnIndex: -1,
                              tableLayout: 'fixed',
                              searchFieldAlignment: 'left',
                              // paginationType: 'stepped',
                              // pageSize: rowData.orders.length,
                              // pageSizeOptions: [],
                              headerStyle: {
                                 backgroundColor: "#FEF3EA",
                                 padding: '8px 0 8px 16px'
                              },
                              filterCellStyle: {
                                 backgroundColor: '#fef3ea',
                                 padding: '8px 0 8px 16px'
                              },
                              searchFieldStyle: {
                                 borderRadius: '20px',
                                 border: '1px solid grey',
                                 padding: '5px 35px',
                                 marginBottom: '10px',
                                 display: 'none'
                              },
                              paging: false,
                              search: false,
                              maxBodyHeight: 'auto', // Automatically adjust body height
                              rowStyle: {
                                 height: "10px", // Set row height to auto
                              },
                           }} />
                     </div>
                  </div>
               )
            }}
            onRowClick={(event, rowData, togglePanel) => togglePanel()}
         />
      </div>
   )
}

export default PaymentByChef